<div class="is-flex align-center height-100-pct">
    <div class="has-text-centered width-100-pct">
        <div>You do not have access to this page</div>
        <app-button
            [buttonText]="'To return home click here'"
            (buttonClick)="goHome()"
            [type]="'stroked'"
        />
        <app-button
            [buttonText]="'To log out click here'"
            (buttonClick)="logout()"
            [type]="'stroked'"
        />
    </div>
</div>
